import React, { useState, useEffect  } from 'react'
import Common from '../../utils/common';
import Configuration from '../../config';
import Pagination from "react-js-pagination";
import $ from "jquery"
import {useLocation} from 'react-use';

export default function List (props){
    const state = useLocation();
    const [page, setPage] = useState(1);
    useEffect(() => {        
        console.log(state);
        if(state.hash != ""){                            
            setPage(state.hash.replace("#",""));
        }
      },[state]);
    const [build, setBuild] = useState();
    
    var paramId = props.match.params.id;
    var paramKeyword = props.match.params.keyword;

    if (paramKeyword == undefined) {
        var url = new URL(window.location.href);
        paramKeyword = url.searchParams.get("keyword");
    }

    if (paramKeyword == undefined || paramKeyword == '') {
        paramKeyword = ''
    }
    var param = {};
    param['paramId'] = paramId;
    param['paramKeyword'] = paramKeyword;
    useEffect(() => {        
        setBuild(Common.getPage('search', param, page))
        
      },[page]);
      useEffect(() => {               
        window.Merchant.initEvent();
        
      },[build]);
    return (
        <div dangerouslySetInnerHTML={{ __html: build }}>
        </div>
    )
}

